import React, { Component } from 'react'
import CoverImage from '../../../../SPRINTA/atoms/CoverImage'
import { FluidContainer, Row, Col } from '../../../../v2SPRINTA/atoms/Grid'

class CreateExperience extends Component {

    render() {
        return (
            <FluidContainer>
                <Row>
                    <CoverImage image={this.props.image} shadow='300' style={{ backgroundColor: '#333', color: '#fff' }}>
                        <Col size='12'>
                            <Row alignItems='center' justifyContent="center"  style={{ minHeight: this.props.minHeight || '530px', padding: '100px 0' }}>
                                <Col size='12 12 10' text='center'>
                                    {this.props.children}
                                </Col>
                            </Row>
                        </Col>
                    </CoverImage>
                </Row>
            </FluidContainer>
        )
    }

}

export default CreateExperience


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/CoverContent/index.js